var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import Orbit, { buildTransform, pullable, pushable, syncable, Source } from '@orbit/data';
import { supportsIndexedDB } from './lib/indexeddb';
import IndexedDBCache from './cache';
const {
  assert,
  deprecate
} = Orbit;
/**
 * Source for storing data in IndexedDB.
 */

let IndexedDBSource = class IndexedDBSource extends Source {
  constructor(settings = {}) {
    assert("IndexedDBSource's `schema` must be specified in `settings.schema` constructor argument", !!settings.schema);
    assert('Your browser does not support IndexedDB!', supportsIndexedDB());
    settings.name = settings.name || 'indexedDB';
    super(settings);
    let cacheSettings = settings.cacheSettings || {
      schema: settings.schema
    };
    cacheSettings.schema = settings.schema;
    cacheSettings.keyMap = settings.keyMap;
    cacheSettings.queryBuilder = cacheSettings.queryBuilder || this.queryBuilder;
    cacheSettings.transformBuilder = cacheSettings.transformBuilder || this.transformBuilder;
    cacheSettings.namespace = cacheSettings.namespace || settings.namespace;
    this._cache = new IndexedDBCache(cacheSettings);
  }

  get cache() {
    return this._cache;
  }

  async upgrade() {
    await this._cache.reopenDB();
  }

  closeDB() {
    deprecate('`closeDB()` must be called as `cache.closeDB()`.');
    return this.cache.closeDB();
  } /////////////////////////////////////////////////////////////////////////////
  // Resettable interface implementation
  /////////////////////////////////////////////////////////////////////////////


  async reset() {
    await this._cache.reset();
  } /////////////////////////////////////////////////////////////////////////////
  // Syncable interface implementation
  /////////////////////////////////////////////////////////////////////////////


  async _sync(transform) {
    if (!this.transformLog.contains(transform.id)) {
      await this._cache.patch(transform.operations);
      await this.transformed([transform]);
    }
  } /////////////////////////////////////////////////////////////////////////////
  // Pushable interface implementation
  /////////////////////////////////////////////////////////////////////////////


  async _push(transform) {
    let results;

    if (!this.transformLog.contains(transform.id)) {
      await this._cache.patch(transform.operations);
      results = [transform];
      await this.transformed(results);
    } else {
      results = [];
    }

    return results;
  } /////////////////////////////////////////////////////////////////////////////
  // Pullable implementation
  /////////////////////////////////////////////////////////////////////////////


  async _pull(query) {
    let operations;
    const results = await this._cache.query(query);

    if (Array.isArray(results)) {
      operations = results.map(r => {
        return {
          op: 'updateRecord',
          record: r
        };
      });
    } else if (results) {
      let record = results;
      operations = [{
        op: 'updateRecord',
        record
      }];
    } else {
      operations = [];
    }

    const transforms = [buildTransform(operations)];
    await this.transformed(transforms);
    return transforms;
  }

};
IndexedDBSource = __decorate([pullable, pushable, syncable], IndexedDBSource);
export default IndexedDBSource;